import PropTypes from 'prop-types'
import Control from 'react-bootstrap/FormControl'
import Svg from 'react-inlinesvg'

import { translate } from '@/utils/translations'

const Errors = ({
  hasValidation,
  errorOverride,
  field: {
    errorId,
    formParent,
    isInvalid,
    key,
  }
}) => {
  let errorText = ''

  if (hasValidation) {
    errorText = errorOverride || translate(`${formParent}.errors.${key}`)
  }

  return (
    <If condition={isInvalid && hasValidation}>
      <Control.Feedback id={errorId} type='invalid'>
        <Svg aria-hidden='true' src={require('./images/exclamation.svg')} />
        <span className='u-push-quarter--left'>{errorText}</span>
      </Control.Feedback>
    </If>
  )
}

export default Errors

Errors.propTypes = {
  errorOverride: PropTypes.string,
  field: PropTypes.shape({
    errorId: PropTypes.string.isRequired,
    formParent: PropTypes.string.isRequired,
    isInvalid: PropTypes.bool.isRequired,
    key: PropTypes.string.isRequired
  }),
  hasValidation: PropTypes.bool,

}
